import React, { useEffect, useState, useContext } from 'react';

import { ResponsiveHeader } from '../responsive-header/ResponsiveHeader';

import { SkipLinks } from '../link-list/SkipLinks';
import { skipLinks } from '../links';
import authenticateUser from '../../../client/authenticate-user';
import { Navigation } from '../navigation/Navigation';
import styles from './header-wrapper.scss';
import { UserContext } from '../../scaffold/UserContext';
import { getUserProfile } from '../../../client/getUserProfile';

export const HeaderWrapper = ({ features }) => {
  const [mobileNavShown, setMobileNavShown] = useState(false);
  const [typeaheadIsOpen, setTypeaheadIsOpen] = useState(false);

  const { updateUserState } = useContext(UserContext);
  const [componentMounted, updateComponentMounted] = useState(false);

  useEffect(() => {
    if (features.authenticationEnabled && !componentMounted) {
      authenticateUser(updateUserState);
    } else if (!features.authenticationEnabled && !componentMounted) {
      const userProfile = getUserProfile();
      updateUserState(userProfile);
    }
    updateComponentMounted(true);
  }, [componentMounted]);

  return (
    <header className={styles.siteWide}>
      <div className={styles.headerContainer}>
        <SkipLinks links={skipLinks} />
        <ResponsiveHeader
          updateMobileNavState={setMobileNavShown}
          updateTypeaheadState={setTypeaheadIsOpen}
        />
      </div>
      <Navigation
        mobileNavShown={mobileNavShown}
        typeaheadIsOpen={typeaheadIsOpen}
      />
    </header>
  );
};
